import { render, staticRenderFns } from "./SubOrgItem.vue?vue&type=template&id=5f773f62&scoped=true&"
import script from "./SubOrgItem.vue?vue&type=script&lang=ts&"
export * from "./SubOrgItem.vue?vue&type=script&lang=ts&"
import style0 from "./SubOrgItem.vue?vue&type=style&index=0&id=5f773f62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f773f62",
  null
  
)

export default component.exports